module.exports = __webpack_public_path__ + "static/media/ATV.svg";